import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_checked_blue",
  "use": "icon-icon_checked_blue-usage",
  "viewBox": "0 0 12 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 8\" id=\"icon-icon_checked_blue\"><path d=\"m4.667 6.115 6.128-6.129.943.943L4.667 8 .424 3.757l.943-.942z\" fill=\"#1F6BF2\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol